export default __webpack_public_path__ + "938159e56a711920f9fcc0594d9f2e4c.png";